import type { Expense } from "@trip/verdant";
import { memo, useRef } from "react";
import isEqual from "react-fast-compare";
import { CATEGORY, PAY_METHOD } from "../const.js";
import {
	IonItem,
	IonItemOption,
	IonItemOptions,
	IonItemSliding,
} from "@ionic/react";
import useConfirm from "@/hooks/useConfirm/index.jsx";
import { useAdd } from "./Add/index.jsx";
import { CURRENCY_CONFIG } from "@/const.js";

const Article = memo(
	({ item, showTime }: { item: Expense; showTime?: boolean }) => {
		const categoryInfo = CATEGORY.find((i) => i.value === item.get("category"));

		const { showModal } = useConfirm({
			// isSubmitting: deleting,
			onSubmit: async () => {
				await item.deleteSelf();
				ref.current?.close();
			},
			title: "确定删除该吗?",
		});

		const { show: addShow } = useAdd({ planId: item.get("planId") });
		const currency = item.get("currency");
		const amount = item.get("amount");

		const currencyInfo = CURRENCY_CONFIG[currency];

		const ref = useRef<{ close: () => void } & HTMLIonItemSlidingElement>(null);
		return (
			<IonItemSliding ref={ref}>
				<IonItem style={{ "--border-color": "#e5e7eb" }}>
					<article className="flex items-center justify-between py-4 w-full  ">
						<i
							className={`w-12 h-12 bg-blue-50 text-2xl rounded-full shrink-0 text-gray-600 ic-round !flex items-center justify-center ${categoryInfo?.icon}`}
						/>
						<div className="flex-grow px-4">
							<b className="font-[600] text-gray-800 text-base block leading-none">
								{item.get("title") || `${categoryInfo?.label}`}
							</b>
							<span className="text-xs text-gray-500">
								{
									PAY_METHOD.find((i) => i.value === item.get("payMethod"))
										?.label
								}{" "}
								{item.get("description")}
							</span>
						</div>
						<div>
							<b className="text-gray-900 font-[din] font-base">
								{currencyInfo?.unit}
								{amount.toLocaleString(undefined, {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})}
							</b>
							{currency !== "CNY" && (
								<span className="text-gray-500 text-right block text-xs">
									￥
									{(amount * currencyInfo?.rate).toLocaleString(undefined, {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									})}
								</span>
							)}
						</div>
					</article>
				</IonItem>

				<IonItemOptions side="end" onIonSwipe={showModal}>
					<IonItemOption
						onClick={() => {
							ref.current?.close();
							addShow({ defaultValue: item.getAll() });
						}}
					>
						<i className="ic-round md-edit w-10 text-center" />
					</IonItemOption>
					<IonItemOption color="danger" expandable onClick={showModal}>
						<i className="ic-round md-delete w-10 text-center" />
					</IonItemOption>
				</IonItemOptions>
			</IonItemSliding>
		);
	},
	isEqual,
);

export default Article;
